import React from "react";

type SortDirection = "asc" | "desc" | null;

interface TableHeaderProps {
  label: string;
}

export const TableHeader: React.FC<TableHeaderProps> = ({ label }) => {
  return (
    <th className="table-header">
      <div className="flex items-center space-x-1">
        <span>{label}</span>
      </div>
    </th>
  );
};
